import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Adjust the path accordingly
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

// Optional: If you want to measure performance
reportWebVitals();
